import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { ModuleCardProps } from "../../Utils/Types";
import style from "../../Styles/courses.module.css";
import previewStyles from "../../Styles/previewPDF.module.css";
import PreviewPDFDoc from "../Widgets/PreviewPDFDoc";
import { useState } from "react";
import Videos from "../Videos/Videos";
import { Vocabulary } from "../../Utils/Vocabulary";

export default function ModuleCard(props: ModuleCardProps) {
  const { module } = props;
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleOnClick = () => {
    setOpen(true);
  };

  const ModuleWrapper = ({
    title,
    children,
  }: {
    children: React.ReactNode;
    title: string;
  }) => {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullScreen={isMobile}
        classes={{ paper: previewStyles.overflowHidden }}
      >
        <DialogTitle className={previewStyles.dialogHeader}>
          <div className={previewStyles.dialogHeaderTitle}>{title}</div>
          <IconButton
            className={previewStyles.closeButton}
            size="large"
            aria-label={Vocabulary.close}
            onClick={() => setOpen(false)}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={style.dialogBody}>{children}</DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      <Card className={style.card} onClick={handleOnClick}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          style={{ display: "flex", justifyContent: "center" }}
        >
          {" "}
          {module.name}
        </Typography>
        {module.mainImageId && (
          <div className={style.cardImage}>
            <img
              width="100"
              src={"/" + module.mainImageId}
              alt={module.name}
              className={style.cardImg}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.visibility = "hidden"; // hide image if not found
              }}
            />
          </div>
        )}
      </Card>
      <ModuleWrapper title={module.name || ""}>
        {module.videos &&
          module.videos.map((video: any, index: number) => {
            return (
              <div key={index}>
                <Videos iframe={video.iframe} />
              </div>
            );
          })}
        <hr />
        <div></div>

        <PreviewPDFDoc
          open={false}
          title={""}
          onClose={() => {
            setOpen(false);
          }}
          htmlContent={""}
          urls={module.documentIds.map((item: any) => {
            return "/" + item.document;
          })}
        />
      </ModuleWrapper>
    </div>
  );
}